<template>
  <a-modal
      title="新建标签"
      :width="960"
      :visible="visible"
      :maskClosable="false"
      @cancel="cancel"
      :destroyOnClose="true"
      :confirmLoading="loading"
      okText="保存"
      @ok="ok">
    <a-form-model :model="tagForm" ref="tagForm" :rules="rules" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="20"
             type="flex"
             align="middle">
        <a-form-model-item label="标签名称" prop="tagName">
          <a-input v-model="tagForm.tagName"
                   placeholder="输入标签名称"
                   :maxLength="10">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="基础颜色" prop="tagColor">
          <dict-cascader dictKey="expert_tag_color"
                         placeholder="请选择基础颜色"
                         style="width: 100%"
                         v-model="tagForm.tagColor"
          />
        </a-form-model-item>
        <a-form-model-item label="抽取优先级" prop="extractPriorityFlag">
          <dict-radio dict-key="expert_extract_priority" v-model="tagForm.extractPriorityFlag"></dict-radio>
        </a-form-model-item>
        <a-form-model-item label="标签描述"
                           prop="tagDetail">
          <a-textarea v-model="tagForm.tagDetail"
                      :atow-size="{minSize:3,maxSize:5}"
                      placeholder="请输入标签描述"/>
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>

import qs from 'qs'
import DictCascader from '@comp/dict/DictCascader'
import DictRadio from '@/components/dict/DictRadio.vue'
import { AddTagInfo } from '@/epp/expertmain/experttag/api/TagApi'

const rules = {
  tagName: [{ required: true, message: '标签名称不能为空！', trigger: 'change' }],
  tagColor: [{ required: true, message: '请选择基础颜色！', trigger: 'change' }],
  extractPriorityFlag: [{ required: true, message: '请选择抽取优先级', trigger: 'change' }],
}

export default {
  name: 'TagAddModal',
  components: {
    DictCascader,
    DictRadio
  },
  created () {
  },
  data () {
    return {
      rules,
      visible: false,
      loading: false,
      tagForm: {
        tagName: undefined,
        tagColor: undefined,
        extractPriorityFlag: undefined,
        tagDetail: undefined
      },
    }
  },
  methods: {
    onStartLoadData () {
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    ok () {
      this.$refs.tagForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          this.loading = true
          const data = { ...this.tagForm }
          let res = await AddTagInfo(data)
          if (200 !== res.code) {
            this.$message.error('添加失败')
            return
          }
          this.visible = false
          this.$message.success('添加成功')
          this.$emit('success')
        } catch (e) {
          this.$message.error(e.message)
        } finally {
          this.loading = false
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
